import React from 'react';
import { Field } from '../../components/ui';

const Row = ({ label, value }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '11px 0', borderBottom: '1px solid var(--line)' }}>
    <span className="muted" style={{ fontSize: 13 }}>{label}</span>
    <span style={{ fontWeight: 600, textAlign: 'right' }}>{value || '—'}</span>
  </div>
);

// Desktop Profile — one card, two-column edit grid.
export default function ProfileDesktop({ vm }) {
  const { user, organiser, roleLabel, fullName, avatar, editing, setEditing, saving, form, setF, saveProfile, doLogout, goChangePassword } = vm;
  return (
    <div>
      <div className="page-head"><h1>My Profile</h1></div>

      <div className="card card-pad" style={{ maxWidth: 520 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 10 }}>
          <div className="avatar avatar-lg">{avatar}</div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700 }}>{fullName || '—'}</div>
            <div className="muted" style={{ fontSize: 13 }}>{roleLabel}</div>
          </div>
        </div>

        {editing ? (
          <div className="form-grid" style={{ marginTop: 14 }}>
            <Field label="Name" value={form.Name} required onChange={v => setF('Name', v)} />
            <Field label="Surname" value={form.Surname} onChange={v => setF('Surname', v)} />
            <Field label="Mobile Number" value={form.MobileNumber} required onChange={v => setF('MobileNumber', v)} />
            <Field label="Email" value={form.EmailId} onChange={v => setF('EmailId', v)} />
            <Field label="New Password" type="password" value={form.Password}
              onChange={v => setF('Password', v)} placeholder="Leave blank to keep current password" />
            <Field label="Confirm Password" type="password" value={form.ConfirmPassword}
              onChange={v => setF('ConfirmPassword', v)} />
          </div>
        ) : (
          <>
            <Row label="User ID" value={user?.UserId} />
            <Row label="Name" value={fullName} />
            <Row label="Mobile Number" value={user?.MobileNumber} />
            <Row label="Email" value={user?.EmailId} />
            <Row label="Organiser" value={organiser?.OrganiserName} />
            <Row label="Role" value={roleLabel} />
          </>
        )}

        <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
          {editing ? (
            <>
              <button className="btn light" style={{ flex: 1 }} disabled={saving} onClick={() => setEditing(false)}>Cancel</button>
              <button className="btn primary" style={{ flex: 1 }} disabled={saving} onClick={saveProfile}>{saving ? 'Saving...' : 'Save Profile'}</button>
            </>
          ) : (
            <>
              <button className="btn primary" style={{ flex: 1 }} onClick={() => setEditing(true)}>Edit Profile</button>
              <button className="btn light" style={{ flex: 1 }} onClick={goChangePassword}>Change password</button>
              <button className="btn danger" style={{ flex: 1 }} onClick={doLogout}>Logout</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
